// Decimals and Commas, $ Optional
const currencyRegex = /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/;
const wholeIntegerRegex = /^-?\d+$/;
const unlimitedDecimalNumberRegex = /^-?\d*\.?\d*$/;
const calcDecimalNumberRegex = /^-?\d+\.?(\d{1,6})?$/;
const maxDecimalNumberRegex = (maxDecimalPlaces = 2) => new RegExp(`^-?\\d+\\.?(\\d{1,${maxDecimalPlaces}})?$`);
export const validateUSDCurrencyValue = val => {
  return currencyRegex.test(val);
};
export const validateWholeInteger = interger => {
  if (interger) {
    return wholeIntegerRegex.test(interger);
  }
  return true;
};
export const validateCalcDecimalNumber = number => {
  return calcDecimalNumberRegex.test(number);
};
export const validateDecimalNumber = (number, maxDecimalPlaces) => {
  if (!maxDecimalPlaces) {
    return unlimitedDecimalNumberRegex.test(number);
  }
  return maxDecimalNumberRegex(maxDecimalPlaces).test(number);
};